import { useState, useEffect, useCallback } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../../../services/firebase";
import { COLLECTIONS } from "../../../../services/collections";
import { useTenant } from "../../../../hooks/useTenant";

export default function useOperationalMetrics() {
    const { idTenant, user } = useTenant();

    const [loading, setLoading] = useState(true);
    const [mySalesTodayCount, setMySalesTodayCount] = useState(0);
    const [mySalesTodayTotal, setMySalesTodayTotal] = useState(0);

    const loadMetrics = useCallback(async () => {
        if (!idTenant || !user?.uid) {
            setLoading(false);
            return;
        }
        setLoading(true);
        try {
            const today = new Date();
            const startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
            const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999);

            const salesRef = collection(db, "tenants", idTenant, COLLECTIONS.SALES);

            // Busca vendas do dia de TODOS os consultores, filtrando pelo Timestamp "date"
            const q = query(
                salesRef,
                where("date", ">=", startOfDay),
                where("date", "<=", endOfDay)
            );

            const snap = await getDocs(q);

            let count = 0;
            let total = 0;

            snap.docs.forEach(doc => {
                const data = doc.data();
                // Filtro local pelo funcionário em questão
                // Tenta achar em idEmployee (quem fez a venda) ou idConsultant (quem estava vinculado)
                if (data.idEmployee === user.uid || data.createdBy?.uid === user.uid || data.idConsultant === user.uid) {
                    count++;
                    total += (Number(data.netAmount) || Number(data.totalAmount) || 0); // O log mostra netAmount ou grossAmount
                }
            });

            setMySalesTodayCount(count);
            setMySalesTodayTotal(total);

        } catch (error) {
            console.error("Erro ao buscar métricas operacionais:", error);
        } finally {
            setLoading(false);
        }
    }, [idTenant, user?.uid]);

    useEffect(() => {
        loadMetrics();
    }, [loadMetrics]);

    return {
        mySalesTodayCount,
        mySalesTodayTotal,
        loading,
        refresh: loadMetrics
    };
}
